import type { ListedFrom, ListedServicePrice } from "@shyne/shared/api";

export type PaymentSource = "custom_pricing" | "default_service" | "fallback";

export interface PaymentCalculationResult {
  payment: number;
  source: PaymentSource;
}

const SOURCE: Record<ListedFrom, PaymentSource> = { propertyPrice: "custom_pricing", catalog: "default_service" };

export const FALLBACK_PAYMENT: PaymentCalculationResult = { payment: 0, source: "fallback" };

export const paymentSuggested = ({ pay, payFrom }: Pick<ListedServicePrice, "pay" | "payFrom">): PaymentCalculationResult =>
  payFrom === null ? FALLBACK_PAYMENT : { payment: pay, source: SOURCE[payFrom] };
